// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pJd94B1Wty8OEsf6Tctw {
  background: var(--header-elevation) !important;
  padding: 0px !important;
  width: 348px !important;
  opacity: 1 !important;
  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);
  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));
  border-radius: 5px;
}

.J7DVAVT9egh5vi7bABcr {
  text-align: left;
  padding: 25px;
}

.mrYDQsC4aWqTcDK7KEXn {
  color: var(--header-title-main);
  font-size: 14px;
}

.HaFEXJABl2NlKieahqhL {
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  row-gap: 25px;
}

.HrL2nZ1vodTf8m7XHGLE {
  font-size: 11px;
  font-weight: 400;
  line-height: 12px;
  color: var(--title-inputs-sections-title);
  display: block;
  margin-bottom: 7px;
  text-transform: uppercase;
}

.XJRM3qAPvVhk4qdlal_V {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
}

.C3M5C0cBfym6YqhCAi3n {
  padding: 5px 12px;
  border-radius: 15px;
  border: 1px solid var(--segments-chips-toggle-stroke-default);
  background: var(--segments-chips-toggle-surface-default);
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: var(--segments-chips-toggle-text-default);
  cursor: pointer;
}

.AR6AlSRf9f9jOS8rcx40 {
  color: var(--segments-chips-toggle-text-active);
  border: 1px solid var(--segments-chips-toggle-stroke-active);
  background: var(--segments-chips-toggle-surface-active);
}

.UMy7Qtg8HCify0F3Gg18 {
  display: none;
}
@media (max-width: 1550px) {
  .UMy7Qtg8HCify0F3Gg18 {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/SiteEngagement/components/AdditionalFilters/style.modules.scss"],"names":[],"mappings":"AA4EA;EAEE,8CAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,iDAAA;EACA,mDAAA;EACA,kBAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,aAAA;AA5EF;;AA+EA;EACE,+BAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AA5EF;;AA+EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AA5EF;;AA+EA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,iBAAA;EACA,mBAAA;EACA,6DAAA;EACA,wDAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gDAAA;EACA,eAAA;AA5EF;;AA+EA;EACE,+CAAA;EACA,4DAAA;EACA,uDAAA;AA5EF;;AA+EA;EACE,aAAA;AA5EF;AA6EE;EAFF;IAGI,aAAA;EA1EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n@import 'src/assets/variables.scss';\n\n.additionalFilters {\n  // importants below to overwrite react-tooltip styles\n  background: var(--header-elevation) !important;\n  padding: 0px !important;\n  width: 348px !important;\n  opacity: 1 !important;\n  box-shadow: 0 3px 8px -1px rgba(50, 50, 71, 0.05);\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 5px;\n}\n\n.tooltipContainer {\n  text-align: left;\n  padding: 25px;\n}\n\n.tooltipTitle {\n  color: var(--header-title-main);\n  font-size: 14px;\n}\n\n.filters {\n  margin-top: 25px;\n  display: flex;\n  flex-direction: column;\n  row-gap: 25px;\n}\n\n.fieldLabel {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 12px;\n  color: var(--title-inputs-sections-title);\n  display: block;\n  margin-bottom: 7px;\n  text-transform: uppercase;\n}\n\n.statusesControlItems {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n}\n\n.statusesControlItem {\n  padding: 5px 12px;\n  border-radius: 15px;\n  border: 1px solid var(--segments-chips-toggle-stroke-default);\n  background: var(--segments-chips-toggle-surface-default);\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 18px;\n  color: var(--segments-chips-toggle-text-default);\n  cursor: pointer;\n}\n\n.activeStatusesControlItem {\n  color: var(--segments-chips-toggle-text-active);\n  border: 1px solid var(--segments-chips-toggle-stroke-active);\n  background: var(--segments-chips-toggle-surface-active);\n}\n\n.smallWidthShow {\n  display: none;\n  @media (max-width: 1550px) {\n    display: flex;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"additionalFilters": `pJd94B1Wty8OEsf6Tctw`,
	"tooltipContainer": `J7DVAVT9egh5vi7bABcr`,
	"tooltipTitle": `mrYDQsC4aWqTcDK7KEXn`,
	"filters": `HaFEXJABl2NlKieahqhL`,
	"fieldLabel": `HrL2nZ1vodTf8m7XHGLE`,
	"statusesControlItems": `XJRM3qAPvVhk4qdlal_V`,
	"statusesControlItem": `C3M5C0cBfym6YqhCAi3n`,
	"activeStatusesControlItem": `AR6AlSRf9f9jOS8rcx40`,
	"smallWidthShow": `UMy7Qtg8HCify0F3Gg18`
};
export default ___CSS_LOADER_EXPORT___;
